import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllSuppliers = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/suppliers',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveSupplier = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/suppliers',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateSupplier = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/suppliers/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteSupplier = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/suppliers/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllSuppliers,
  saveSupplier,
  deleteSupplier,
  updateSupplier,
}
